import { Box, Heading, Text, Button, VStack, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { PRIMARY_COLOR } from "../../constants/colors";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      height="100vh"
      bgGradient="linear(to-b, gray.900, gray.800)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={6}
      color="white"
    >
      <VStack spacing={6} textAlign="center" maxW="lg">
        <Image
          src="https://cdn-icons-png.flaticon.com/512/7486/7486804.png"
          alt="Página não encontrada"
          boxSize="180px"
        />

        <Heading
          fontSize={{ base: "5xl", md: "7xl" }}
          fontWeight="bold"
          color={PRIMARY_COLOR}
          marginTop="20px"
        >
          404
        </Heading>

        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.300"
          marginTop="20px"
        >
          Ops! A página que você está procurando não existe ou foi movida.
        </Text>
      </VStack>
    </Box>
  );
}
